var routeMixin = {
  methods: {
    setQueryParam(key, value) {
      if (this.$route.query[key] != value) {
        var params = {};
        params[key] = value;
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...params
          }
        });
      }
    },
    addQueryParam(key, value) {
      if (this.$route.query[key] != value) {
        var params = {};
        params[key] = value;
        this.$router.push({
          query: {
            ...this.$route.query,
            ...params
          }
        });
      }
    }
  }
};

export default routeMixin;
export { routeMixin };
